import { render, staticRenderFns } from "./SiteUserUpdateSidebar.vue?vue&type=template&id=c36f2c00&scoped=true&"
import script from "./SiteUserUpdateSidebar.vue?vue&type=script&lang=js&"
export * from "./SiteUserUpdateSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SiteUserUpdateSidebar.vue?vue&type=style&index=0&id=c36f2c00&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c36f2c00",
  null
  
)

export default component.exports